import type {
  CosmicProductType,
  CosmicVariationType,
} from '@/lib/cms/cosmic/types/CosmicProductType'
import type { JeevesPricingResponse } from '@/lib/services/Jeeves/pricing/getProductPricing'

type Props = {
  productData: CosmicProductType
  pricingData: JeevesPricingResponse
}

export const assignPricingToVariation = ({
  productData,
  pricingData,
}: Props): CosmicProductType | null => {
  const productDataCopy = { ...productData }

  if (!productDataCopy.variations) return null

  productDataCopy.variations = productDataCopy.variations?.map((variation) => {
    const skuPricing = pricingData.message.find(
      (pricing) => pricing.sku === variation.sku,
    )

    return {
      ...variation,
      pricing: skuPricing || null,
    } as CosmicVariationType // Add type assertion here
  })

  return productDataCopy
}
